import { API_BASE_URL } from "./apiConfig";

/** Always shown on login — matches real SaaS sites. `enabled` comes from API. */
export const DEFAULT_SOCIAL_PROVIDERS = [
  {
    id: "microsoft",
    label: "Microsoft",
    brand: "microsoft",
    enabled: false,
    login_url: `${API_BASE_URL}/auth/microsoft/login`,
    primary: true,
  },
  {
    id: "facebook",
    label: "Facebook",
    brand: "facebook",
    enabled: false,
    login_url: `${API_BASE_URL}/auth/facebook/login`,
  },
  {
    id: "google",
    label: "Google",
    brand: "google",
    enabled: false,
    login_url: `${API_BASE_URL}/auth/google/login`,
  },
  {
    id: "twitter",
    label: "Twitter",
    brand: "twitter",
    enabled: false,
    login_url: `${API_BASE_URL}/auth/twitter/login`,
  },
  {
    id: "apple",
    label: "Apple",
    brand: "apple",
    enabled: false,
    login_url: `${API_BASE_URL}/auth/apple/login`,
  },
];

export function mergeSocialProviders(apiProviders, { googleClientId } = {}) {
  const byId = Object.fromEntries((apiProviders || []).map((p) => [p.id, p]));
  return DEFAULT_SOCIAL_PROVIDERS.map((fallback) => {
    const merged = {
      ...fallback,
      ...byId[fallback.id],
      label: byId[fallback.id]?.label || fallback.label,
      brand: byId[fallback.id]?.brand || fallback.brand,
      login_url: byId[fallback.id]?.login_url || fallback.login_url,
    };
    if (merged.id === "google" && googleClientId) {
      merged.enabled = true;
    }
    return merged;
  });
}

export function resolveGoogleClientId(loginOptions) {
  return (
    loginOptions?.google_client_id ||
    process.env.REACT_APP_GOOGLE_CLIENT_ID ||
    null
  );
}
